import { render, staticRenderFns } from "./AuthorModal.vue?vue&type=template&id=228ba792&scoped=true"
import script from "./AuthorModal.vue?vue&type=script&lang=js"
export * from "./AuthorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.5.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ba792",
  null
  
)

export default component.exports